import { Box } from '@mui/material';
import Header from '../Header';
import { memo } from 'react';
import SideMenu from '../SideMenu';

type LayoutProps = {
  children?: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  return (
    <Box display="flex">
      <SideMenu />
      <Box sx={{ flexGrow: 1 }}>
        <Header />
        <Box component="main" p={{ xs: 0, sm: 4 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default memo(Layout);
